<div class="header">
  <!-- Primary navigation -->
  <nav class="menu-bar" aria-label="Primary">
    <ul>
      @if (!authType.isLoggedInVar) {
        <li>
          <a href="javascript:void(0)" id="activeEle" (click)="goToPublicSearch()">Public Citation Search</a>
        </li>
      }
    </ul>

    @if (authType.menuType === 'ROLE_NON_ADMIN' || authType.menuType === 'ROLE_ADMIN' && authType.isNonAdminActive) {
      <ul class="m-0"
        aria-label="Non-admin navigation">
        @if (authType.menuView) {
          <li>
            <a id="activeEle1" href="javascript:void(0)" (click)="goToAdminPage('ROLE_ADMIN')"><span>Switch to
            Admin</span></a>
          </li>
        }
        <li>
          <a href="javascript:void(0)" (click)="goToEcitation()" id="eCitation Search">
            <span>eCitation Search</span>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" (click)="goToErrorDocSearch()" id="Error Doc Search">
            <span>Error Doc Search</span>
          </a>
        </li>
        <li class="nav-item" ngbDropdown [autoClose]="'outside'" [open]="isMenuOpen('reports')"
          (openChange)="onDropdownOpenChange($event, 'reports')" (focusout)="onMenuFocusOut($event, 'reports')"
          (keydown)="onMenuKeydown($event, 'reports')">
          <!-- Toggle: open on hover or keyboard focus -->
          <button type="button" ngbDropdownToggle class="nav-link" id="Reports" (mouseenter)="openMenu('reports')"
            (focus)="openMenu('reports')" [attr.aria-expanded]="isMenuOpen('reports')" aria-haspopup="menu"
            aria-controls="reports-menu">
            Reports
          </button>
          <!-- Menu: keep open while hovered/focused; close on mouseleave/ESC -->
          <div ngbDropdownMenu id="reports-menu" aria-labelledby="Reports" class="dropdown-menu" role="menu"
            (mouseenter)="openMenu('reports')" (mouseleave)="closeMenu('reports')" (click)="closeAllMenus()">
            <button ngbDropdownItem routerLink="/secure/deliverysummaryReport" role="menuitem">
              Delivery Summary Report
            </button>
            <button ngbDropdownItem routerLink="/secure/deliveryAnnualReport" role="menuitem">
              Delivery Annual Report
            </button>
            <button ngbDropdownItem routerLink="/secure/agencySummaryReport" role="menuitem">
              Agency Summary Report
            </button>
            <button ngbDropdownItem routerLink="/secure/agencyAnnualReport" role="menuitem">
              Agency Annual Report
            </button>
            <button ngbDropdownItem routerLink="/secure/hourlyUsageReport" role="menuitem">
              Hourly Usage Report
            </button>
            <button ngbDropdownItem routerLink="/secure/dayofweekUsageReport" role="menuitem">
              Day of Week Usage Report
            </button>
          </div>
        </li>
      </ul>
    }

    @if (authType.menuType === 'ROLE_ADMIN' && !authType.isNonAdminActive) {
      <ul class="m-0"
        aria-label="Admin navigation">
        <li>
          <a id="activeEle" href="javascript:void(0)" (click)="goToAdminPage('ROLE_NON_ADMIN')">
            <span>Switch to Non Admin</span>
          </a>
        </li>
        <!-- System -->
        <li class="nav-item" ngbDropdown [autoClose]="'outside'" [open]="isMenuOpen('system')"
          (openChange)="onDropdownOpenChange($event, 'system')" (focusout)="onMenuFocusOut($event, 'system')"
          (keydown)="onMenuKeydown($event, 'system')">
          <button type="button" ngbDropdownToggle class="nav-link" id="System" (mouseenter)="openMenu('system')"
            (focus)="openMenu('system')" [attr.aria-expanded]="isMenuOpen('system')" aria-haspopup="menu"
            aria-controls="system-menu">
            System
          </button>
          <div ngbDropdownMenu id="system-menu" aria-labelledby="System" class="dropdown-menu" role="menu"
            (mouseenter)="openMenu('system')" (mouseleave)="closeMenu('system')" (click)="closeAllMenus()">
            <button ngbDropdownItem (click)="gotoMuniStatus()" role="menuitem">Muni</button>
          </div>
        </li>
        <!-- Workflow Apps -->
        <li class="nav-item" ngbDropdown [autoClose]="'outside'" [open]="isMenuOpen('workflow')"
          (openChange)="onDropdownOpenChange($event, 'workflow')" (focusout)="onMenuFocusOut($event, 'workflow')"
          (keydown)="onMenuKeydown($event, 'workflow')">
          <button type="button" ngbDropdownToggle class="nav-link" id="workflow-apps"
            (mouseenter)="openMenu('workflow')" (focus)="openMenu('workflow')"
            [attr.aria-expanded]="isMenuOpen('workflow')" aria-haspopup="menu" aria-controls="workflow-apps-menu">
            Workflow Apps
          </button>
          <div ngbDropdownMenu id="workflow-apps-menu" aria-labelledby="workflow-apps" class="dropdown-menu"
            role="menu" (mouseenter)="openMenu('workflow')" (mouseleave)="closeMenu('workflow')"
            (click)="closeAllMenus()">
            <button ngbDropdownItem (click)="goToEcitationSearch()" role="menuitem">Authenticated Citation
            Search</button>
            <button ngbDropdownItem routerLink="/secure/publicCitationSearch" role="menuitem">Public Citation
            Search</button>
          </div>
        </li>
        <!-- Access Management -->
        <li class="nav-item" ngbDropdown [autoClose]="'outside'" [open]="isMenuOpen('access')"
          (openChange)="onDropdownOpenChange($event, 'access')" (focusout)="onMenuFocusOut($event, 'access')"
          (keydown)="onMenuKeydown($event, 'access')">
          <button type="button" ngbDropdownToggle class="nav-link" id="access-management"
            (mouseenter)="openMenu('access')" (focus)="openMenu('access')"
            [attr.aria-expanded]="isMenuOpen('access')" aria-haspopup="menu" aria-controls="access-management-menu">
            Access Management
          </button>
          <div ngbDropdownMenu id="access-management-menu" aria-labelledby="access-management" class="dropdown-menu"
            role="menu" (mouseenter)="openMenu('access')" (mouseleave)="closeMenu('access')"
            (click)="closeAllMenus()">
            @if (authType.getUserType() !== 'D') {
              <button ngbDropdownItem class="d-block"
              routerLink="/secure/ecitationCourt" role="menuitem">Courts</button>
            }
            @if (authType.getUserType() === 'S' || authType.getUserType() === 'V') {
              <button ngbDropdownItem
              class="d-block" routerLink="/secure/ecitationVendor" role="menuitem">Vendors</button>
            }
            <button ngbDropdownItem class="d-block" routerLink="/secure/ecitationUsers"
            role="menuitem">Users</button>
          </div>
        </li>
      </ul>
    }
  </nav>

  <!-- Right/user menu -->
  <nav class="menu-bar nav-right" role="navigation" aria-label="User">
    <ul>
      @if (!authType.isLoggedInVar) {
        <li class="logout">
          <ng-container>
            <a href="javascript:void(0)" id="Sign in" (click)="goToLogin()">Sign in</a>
          </ng-container>
        </li>
      }

      @if (authType.isLoggedInVar) {
        <li class="logout">
          <a href="javascript:void(0)" id="Sign out" (click)="logout()">Sign out</a>
        </li>
      }
    </ul>
    <span aria-live="polite">{{ getCurrentTime() }}</span>
  </nav>

</div>
